import axios from 'axios';

export default {
  props: {
    setLoadingOverlay: {
      type: Function,
      required: true,
    },
    storeModule: {
      type: String,
      default: '',
    },
  },

  methods: {
    refresh() {
      this.setLoadingOverlay(true);
      this.fetchCollection()
        .then(() => {
          this.setLoadingOverlay(false);
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            return;
          }
          this.setLoadingOverlay(false);
        });
    },

    /**
     * @param [Object, Array] filter - May be a single filter or multiple filters
     */
    handleDropDownAction(filter) {
      if (filter instanceof Array) {
        this.setFilters({ filtersArray: [...filter] });
      } else {
        this.setFilter({ filter });
      }
      this.refresh();
    },

    handleMounted() {
      const filters = this.getFilters;

      if (filters && filters.length) {
        this.$nextTick(() => {
          this.setFilters({ filtersArray: filters });
          this.refresh();
        });
      }
    },
  },
};
